var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_1133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.16732 14H19.834V16.3333H8.16732V14ZM8.16732 21H16.334V18.6667H8.16732V21ZM25.6673 8.85033V28H2.33398V3.5C2.33398 2.57174 2.70273 1.6815 3.35911 1.02513C4.01549 0.368749 4.90573 0 5.83398 0L16.817 0L25.6673 8.85033ZM17.5007 8.16667H21.6843L17.5007 3.983V8.16667ZM23.334 25.6667V10.5H15.1673V2.33333H5.83398C5.52457 2.33333 5.22782 2.45625 5.00903 2.67504C4.79023 2.89383 4.66732 3.19058 4.66732 3.5V25.6667H23.334Z",
    fill: "#FF7180"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_1133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon_document.35d46cf1d72bca02dd9bfc2c2f04c542.svg";
export { ForwardRef as ReactComponent };